import * as yup from "yup";

import { PlansDuration } from "@/constants/plansDuration";
import { EDuration } from "@/api/types/plans";

export default yup
    .object()
    .shape({
        isActive: yup.boolean().required("Active status is required"),
        price: yup.number().positive("Price must be a positive number").required("Price is required"),
        en_title: yup
            .string()
            .min(2, "English title must be at least 2 characters")
            .max(80, "English title must be at most 80 characters")
            .required("English title is required"),
        ar_title: yup
            .string()
            .min(2, "Arabic title must be at least 2 characters")
            .max(80, "Arabic title must be at most 80 characters")
            .required("Arabic title is required"),
        en_name: yup
            .string()
            .min(2, "English name must be at least 2 characters")
            .max(80, "English name must be at most 80 characters")
            .required("English name is required"),
        ar_name: yup
            .string()
            .min(2, "Arabic name must be at least 2 characters")
            .max(80, "Arabic name must be at most 80 characters")
            .required("Arabic name is required"),
        en_description: yup.string().max(600, "English description must be at most 600 characters"),
        ar_description: yup.string().max(600, "Arabic description must be at most 600 characters"),
        en_trialTitle: yup.string().when("hasTrial", {
            is: (value: boolean) => !!value,
            then: () =>
                yup
                    .string()
                    .min(2, "English trial title must be at least 2 characters")
                    .max(80, "English trial title must be at most 80 characters")
                    .required("English trial title is required when Has Trial is selected"),
            otherwise: () => yup.string().max(80, "English trial title must be at most 80 characters"),
        }),
        ar_trialTitle: yup.string().when("hasTrial", {
            is: (value: boolean) => !!value,
            then: () =>
                yup
                    .string()
                    .min(2, "Arabic trial title must be at least 2 characters")
                    .max(80, "Arabic trial title must be at most 80 characters")
                    .required("Arabic trial title is required when Has Trial is selected"),
            otherwise: () => yup.string().max(80, "Arabic trial title must be at most 80 characters"),
        }),
        en_trialSubtitle: yup.string().when("hasTrial", {
            is: (value: boolean) => !!value,
            then: () =>
                yup
                    .string()
                    .min(2, "English trial subtitle must be at least 2 characters")
                    .max(120, "English trial subtitle must be at most 120 characters")
                    .required("English trial subtitle is required when Has Trial is selected"),
            otherwise: () => yup.string().max(120, "English trial subtitle must be at most 120 characters"),
        }),
        ar_trialSubtitle: yup.string().when("hasTrial", {
            is: (value: boolean) => !!value,
            then: () =>
                yup
                    .string()
                    .min(2, "Arabic trial subtitle must be at least 2 characters")
                    .max(120, "Arabic trial subtitle must be at most 120 characters")
                    .required("Arabic trial subtitle is required when Has Trial is selected"),
            otherwise: () => yup.string().max(120, "Arabic trial subtitle must be at most 120 characters"),
        }),
        en_subtitle: yup
            .string()
            .min(2, "English subtitle must be at least 2 characters")
            .max(120, "English subtitle must be at most 120 characters")
            .required("English subtitle is required"),
        ar_subtitle: yup
            .string()
            .min(2, "Arabic subtitle must be at least 2 characters")
            .max(120, "Arabic subtitle must be at most 120 characters")
            .required("Arabic subtitle is required"),
        features: yup
            .array(
                yup.object({
                    en: yup.string().required("English feature is required"),
                    ar: yup.string().required("Arabic feature is required"),
                    icon: yup.string().required("Icon is required"),
                })
            )
            .min(1, "At least 1 feature is required")
            .required("Features are required"),
        hasTrial: yup.boolean(),
        showInWeb: yup.boolean(),
        showInApp: yup.boolean(),
        googleProductId: yup.string().when("showInApp", {
            is: (value: boolean) => value,
            then: () => yup.string().required("Google Product Id is required"),
        }),
        appleProductId: yup.string().when("showInApp", {
            is: (value: boolean) => value,
            then: () => yup.string().required("Apple Product Id is required"),
        }),
        paddleProductId: yup.string().when("showInWeb", {
            is: (value: boolean) => value,
            then: () => yup.string().required("Paddle Product Id is required"),
        }),
        paddleTrialProductId: yup.string().when(["showInWeb", "hasTrial"], {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            is: (showInWeb: any, hasTrial: any) => !!showInWeb && !!hasTrial,
            then: () => yup.string().required("Paddle Trial Product Id is required when Has Trial is selected"),
        }),
        currency: yup
            .string()
            .oneOf(["KWD", "BHD", "OMR", "AED", "SAR", "USD"], "Invalid currency")
            .required("Currency is required"),
        duration: yup.string().required("Duration is Required"),
        trialDuration: yup.string().when("hasTrial", {
            is: (value: boolean) => !!value,
            then: () => yup.string().required("Trial Period is required when Has Trial is selected"),
        }),
    })
    .test(
        "at-least-one-checked",
        "At least one of 'Show in Web' or 'Show in App' must be selected",
        (values) => values.showInWeb || values.showInApp
    );
